import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AuthGuard } from './core/guards/auth.guard';
import { RedirectLogoutComponent } from './modules/common-pages/redirect-logout/redirect-logout.component';
import { UserResolverService } from './modules/auth/service/user-resolver.service';
import { roleGuard } from './modules/tenant-onboarding/role.guard';
import { RouteRenderModalComponent } from './shared/components/route-render-modal/route-render-modal.component';
import { MissingInfoModalComponent } from './modules/home/components/missing-info-modal/missing-info-modal.component';
import { profileCompletionPage } from './shared/utilities/constants';
import { ProfileCheckGuard } from './core/guards/profileCheck.guard';
import { homeRootBypassGuard } from './core/guards/home-root-bypass.guard';

const routes: Routes = [
  {
    path: '',
    loadChildren: () => import('./modules/home/home.module').then(m => m.HomeModule),
    canActivate: [AuthGuard, homeRootBypassGuard, ProfileCheckGuard],
    canActivateChild: [homeRootBypassGuard],
    resolve:[UserResolverService]
  },
  {
    path: 'missing-info',
    component: MissingInfoModalComponent,
  },
  {
    path: profileCompletionPage.modalType.profileCompletion,
    component: RouteRenderModalComponent,
    outlet: 'modal',
    data: profileCompletionPage.defaultConfig,
    children: [
      {
        path: '',
        loadComponent: () => import('./modules/home/components/missing-info-modal/missing-info-modal.component').then(m => m.MissingInfoModalComponent)
      }
    ]
  },
  {
    path: profileCompletionPage.modalType.surveyCompletion,
    component: RouteRenderModalComponent,
    outlet: 'modal',
    data: profileCompletionPage.defaultConfig,
    children: [
      {
        path: '',
        loadComponent: () => import('./modules/home/components/missing-info-modal/missing-info-modal.component').then(m => m.MissingInfoModalComponent)
      }
    ]
  },
  {
    path: 'auth',
    loadChildren: () => import('./../app/modules/auth/auth.module').then(m => m.AuthModule),
  },
  {
    path: 'account',
    loadChildren: () => import('./modules/accounts/accounts.module').then(m => m.AccountsModule),
    canActivate: [AuthGuard,homeRootBypassGuard, ProfileCheckGuard],
    canActivateChild: [homeRootBypassGuard],
    resolve:[UserResolverService]
  },
  {
    path: 'privacy',
    redirectTo: 'support/privacy'
  },
  {
    path: 'termsandconditions',
    redirectTo: 'support/termsandconditions'
  },
  {
    path: 'clearcache',
    redirectTo: 'support/clearcache'
  },
  {
    path: 'auth-redirect',
    component: RedirectLogoutComponent
  },
  {
    path: 'support',
    loadChildren: () => import('./modules/common-pages/common-pages.module').then(m => m.CommonPagesModule),
  },
  {
    path: 'admin',
    loadChildren: () => import('./modules/tenant-onboarding/tenant-admin-routing.module').then(m => m.ROUTES),
    canActivate: [AuthGuard]
  },
  {
    path: '**',
    redirectTo: 'support/page-not-found'
  },

];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
